// Renders the 'Created by' line used by message details.
import { timeFormatOptions } from './timezones';

export const renderCreatedBy = createdBy =>
  createdBy?.firstName && createdBy?.lastName
    ? [
        {
          label: 'Created by',
          value: `${createdBy?.firstName || ''} ${createdBy?.lastName || ''}`,
        },
      ]
    : [];

function isDateInFuture(dateString) {
  const inputDate = new Date(dateString);
  const currentUtcTime = new Date();

  return currentUtcTime < inputDate;
}

export const renderSendTime = (status, sendAt, sendAtUtc, updatedAt) => {
  if (sendAt) {
    const scheduledLabel = isDateInFuture(sendAtUtc) ? 'Scheduled for' : 'Sent at';

    return [
      {
        label: scheduledLabel,
        value: `${new Date(sendAt).toLocaleString('us-US', timeFormatOptions)}`,
      },
    ];
  }

  if (status === 'P') {
    return [
      {
        label: 'Sent at',
        value: `${new Date(updatedAt).toLocaleString('us-US', timeFormatOptions)}`,
      },
    ];
  }

  return [];
};
